export default __webpack_public_path__ + "static/media/image4.c367868f.jpg";